import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import actions from "../../actions"
import { action, global } from '../../utils';
import axios from "axios";
import SnackMessage from '../../components/SnackMessage';
import { LoadingDialog } from "../../components/SharedComponents";
import RecordExceptionDialog from '../../shared/components/modal/RecordExceptionDialog';
// import localize from '../../shared/localize';

class SettingsProvider extends Component {

    constructor(props) {
        super(props);
        const { search } = props.history.location;
        const queryString = new URLSearchParams(search)
        let domain = queryString.get("http") || global.main_server,
            isWebview = queryString.get("isWebview"),
            socket = queryString.get("socket") || global.main_server;

        window.socketURL = `wss://${socket}/wsg`;
        window.baseURL = domain;
        window.wv = isWebview && isWebview === "1";
        axios.defaults.baseURL = `https://${domain}/woogi/0.1/actor/cgi.php`;
    }

    async componentDidMount() {
        // window.document.title = global.app_code === "dv" ? localize.Daily_Vitals_powered_by_Woogi : localize.English_Vitals_powered_by_Woogi;
        window.addEventListener("online", () => this.props.isOnline());
        window.addEventListener("offline", () => this.props.isOffline());
        window.addEventListener("resize", () => this.props.isResize());
    }

    componentWillUnmount() {
        window.removeEventListener("resize", null);
        window.removeEventListener("online", null);
        window.removeEventListener("offline", null);
    }

    render() {
       
        return (
            <React.Fragment>
                {this.props.children}
                <SnackMessage />
                <LoadingDialog />
                <RecordExceptionDialog />
            </React.Fragment>
        )
    }
}

function mapStateToProps({ }) {
    return {

    }
}

const mapDispatch = (dispatch) => {
    return {
        isOnline: () => dispatch({ type: action.IS_USER_ONLINE }),
        isOffline: () => dispatch({ type: action.IS_USER_OFFLINE }),
        isResize: () => dispatch({ type: action.IS_WINDOW_RESIZE }),
        auth: dispatch(actions.checkWebAuth()),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatch)(SettingsProvider));
